import { CheckCircleOutline, Close } from '@mui/icons-material'
import { GridColDef, GridValidRowModel, getGridBooleanOperators } from '@mui/x-data-grid-premium'
import { isDefined } from 'utils/type-guard/isDefined'
import { BaseColumnConfig } from '../types'
import { transformBooleanOption } from '../utils/booleanFilterUtils'
import { baseColumnConfig } from './baseColumnConfig'

export type BooleanColumnConfig<T extends GridValidRowModel> = BaseColumnConfig<T, 'boolean'> & {
  columnType: 'boolean'
}

export const getBooleanColumn = <T extends GridValidRowModel>({ style, ...config }: BooleanColumnConfig<T>): GridColDef<T> => ({
  ...baseColumnConfig,
  ...style,
  ...config,
  type: 'boolean',
  // Override filter operators to use actual boolean values instead of strings
  filterOperators: getGridBooleanOperators().map((operator) => ({
    ...operator,
    // Override the InputComponent to use boolean values
    InputComponentProps: {
      ...operator.InputComponentProps,
      // Transform the valueOptions to use actual booleans (case-insensitive)
      valueOptions: operator.InputComponentProps?.valueOptions?.map(transformBooleanOption),
    },
  })),
  renderCell: (params) =>
    !isDefined(params.value) ? null : params.value === true ? (
      <CheckCircleOutline {...(config?.getDataTestId ? { ['data-testid']: config.getDataTestId(params) } : {})} color="success" />
    ) : (
      <Close {...(config?.getDataTestId ? { ['data-testid']: config.getDataTestId(params) } : {})} color="neutral" />
    ),
})
